var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('page-title', {
    attrs: {
      "title": "Homepage",
      "icon": "pe-7s-display2"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }